import { TooltipsEnum, TravelGoalDescriptionEnum } from 'app/shared/enums';
import { Dictionary } from 'app/services/dict.service';

export const travelGoalsDescriptionsDictionary: Dictionary<{
  key: TravelGoalDescriptionEnum;
  value: TooltipsEnum;
}> = [
  {
    key: TravelGoalDescriptionEnum.Sightseeing,
    value: TooltipsEnum.TravelGoalSightseeing,
  },
  {
    key: TravelGoalDescriptionEnum.Skiing,
    value: TooltipsEnum.TravelGoalSkiing,
  },
  {
    key: TravelGoalDescriptionEnum.Diving,
    value: TooltipsEnum.TravelGoalDiving,
  },
  {
    key: TravelGoalDescriptionEnum.ExtremeSports,
    value: TooltipsEnum.TravelGoalExtremeSports,
  },
  {
    key: TravelGoalDescriptionEnum.CompetitiveSports,
    value: TooltipsEnum.TravelGoalCompetitiveSports,
  },
  {
    key: TravelGoalDescriptionEnum.PhysicalWork,
    value: TooltipsEnum.TravelGoalPhysicalWork,
  },
  {
    key: TravelGoalDescriptionEnum.BusinessTrip,
    value: TooltipsEnum.TravelGoalBusinessTrip,
  },
];
